import React from 'react'

export const HeaderDisplayAreas = {
  NoPicture: 'NoPicture',
  TitleOnly: 'TitleOnly',
  NoActions: 'NoActions',
  All: 'All'
}

export function HeaderDisplay (props) {
  const { title, subTitle, blue } = props
  const color = blue ? 'blue' : 'teal'

  return <div className={`slide-pane-head-${color}-title`}>{title}<span>{subTitle}</span></div>
}
